import { useState } from "react";
import { Inbox } from "lucide-react";
import { AdminTitle } from "@/admin/AdminLayout";
import { FilterBar, DecisionButtons } from "@/admin/Decision";
import { StatusBadge } from "@/components/Brand";
import { useApi } from "@/lib/api";
import { rp, fmtDateTime, KIND_LABEL, METHOD_LABEL, fmtAcc } from "@/lib/format";

const Detail = ({ r }) => {
  if (r.kind === "transfer_bank") return <>Ke <b>{r.bank_name}</b> • {r.account_no} • a.n. {r.recipient_name}</>;
  if (r.kind === "transfer_member") return <>Ke anggota <b>{r.recipient_name}</b> ({r.target_account_no ? `Rek. ${fmtAcc(r.target_account_no)}` : r.target_member_no})</>;
  if (r.kind === "setoran") return <>Simpanan {r.savings_type}</>;
  return null;
};

export default function AdminRequests() {
  const { data, reload } = useApi("/admin/requests");
  const [filter, setFilter] = useState("pending");
  const list = (data || []).filter((r) => filter === "all" || r.status === filter);
  return (
    <div>
      <AdminTitle icon={Inbox} title="Pembayaran & Transfer" sub="Verifikasi pembayaran masuk dan proses transfer secara manual, lalu tandai di sini" />
      <FilterBar value={filter} onChange={setFilter} />
      <div className="space-y-3" data-testid="admin-requests-list">
        {list.length === 0 && <p className="text-sm text-slate-500" data-testid="admin-requests-empty">Tidak ada data.</p>}
        {list.map((r) => (
          <div key={r.req_id} className="bg-white rounded-2xl border border-slate-200 p-4 flex flex-col lg:flex-row lg:items-center gap-3 justify-between">
            <div>
              <div className="flex items-center gap-2 flex-wrap"><b>{KIND_LABEL[r.kind]}</b><StatusBadge status={r.status} /><span className="text-xs text-slate-500">{fmtDateTime(r.created_at)}</span></div>
              <div className="text-sm mt-1">{r.member_name} ({r.member_no}) • <b>{rp(r.amount)}</b> • {METHOD_LABEL[r.method]}</div>
              <div className="text-xs text-slate-600"><Detail r={r} /></div>
              {(r.reference || r.note) && <div className="text-xs text-slate-500">{r.reference && `Ref: ${r.reference} `}{r.note && `• Catatan: ${r.note}`}</div>}
              {r.admin_note && <div className="text-xs text-slate-700">Catatan admin: {r.admin_note}</div>}
            </div>
            {r.status === "pending" && <DecisionButtons url={`/admin/requests/${r.req_id}/decision`} id={r.req_id} onDone={reload} />}
          </div>
        ))}
      </div>
    </div>
  );
}
